import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Model from './components/Model';
import Features from './components/Features';
import Team from './components/Team';
import Footer from './components/Footer';
import Contact from './components/Contact';
import RobotCanvas from './components/RobotCanvas';

import Login from '@/admin/pages/Login';
import AdminLayout from '@/admin/components/AdminLayout';
import Dashboard from '@/admin/pages/Dashboard';
import HeroEditor from '@/admin/pages/HeroEditor';
import AdminSettings from '@/admin/pages/AdminSettings';
import BrandingManager from '@/admin/pages/BrandingManager';

import ModelManager from '@/admin/pages/ModelManager';
import ModelEditor from '@/admin/pages/ModelEditor';
import HighlightsEditor from '@/admin/pages/HighlightsEditor';
import BentoEditor from '@/admin/pages/BentoEditor';
import ContactEditor from '@/admin/pages/ContactEditor';
import FooterEditor from '@/admin/pages/FooterEditor';
import NavEditor from '@/admin/pages/NavEditor';
import TeamManager from '@/admin/pages/TeamManager';

import * as Sentry from '@sentry/react';

const PublicSite = () => (
  <main className="bg-white dark:bg-black transition-colors duration-500">
    <RobotCanvas />
    <Navbar />
    <Hero />
    <Highlights />
    <Model />
    <Features />
    <Team />
    <Contact />
    <Footer />
  </main>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="branding" element={<BrandingManager />} />
          <Route path="hero" element={<HeroEditor />} />
          <Route path="models" element={<ModelManager />} />
          <Route path="models/edit/:id" element={<ModelEditor />} />
          <Route path="highlights" element={<HighlightsEditor />} />
          <Route path="bento" element={<BentoEditor />} />
          <Route path="contact" element={<ContactEditor />} />
          <Route path="footer" element={<FooterEditor />} />
          <Route path="nav" element={<NavEditor />} />
          <Route path="team" element={<TeamManager />} />
          <Route path="settings" element={<AdminSettings />} />
          {/* Add other admin routes here */}
        </Route>

        <Route path="/" element={<PublicSite />} />
      </Routes>
    </Router>
  )
}

export default Sentry.withProfiler(App);
